import SgpForm from './form.vue'

SgpForm.install = function (Vue) {
  Vue.component(SgpForm.name, SgpForm)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(SgpForm)
}

export default SgpForm
